import type { JSX } from 'react';

import { ArrowRightUp } from '@remarkable/ark-icons';
import { Typography } from '@remarkable/ark-web';

import { ComponentLocations } from 'src/analytics/trackingTypes';

import { LinkExternal } from './LinkExternal';

export const FAQLine = ({
  text,
  target,
}: {
  text: string | JSX.Element;
  target: string;
}) => {
  return (
    <li className="text-line border-b border-divider py-24 leading-150">
      <LinkExternal
        to={target}
        className="flex w-full justify-between"
        componentLocation={ComponentLocations.FAQ.MAIN}
      >
        <Typography
          as="span"
          variant="body-md"
          fontWeight="medium"
          className="max-w-[90%]"
        >
          {text}
        </Typography>
        <ArrowRightUp />
      </LinkExternal>
    </li>
  );
};
